import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftSpeedListItem = (props) => {
    const { speed, updateBackgroundSettings } = props;

    const onSpeedChange = (value) => updateBackgroundSettings({ drift: { speed: value } });

    return (
        <SliderListItem
            title='Speed'
            displayMultiplier={50}
            value={speed}
            min={0}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { speed } = state.createPreview.present.videoSettings.background.drift;
    return { speed };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftSpeedListItem);
